import React from 'react';
import ContentLoader from 'react-content-loader';
import classNames from 'classnames';

const CommunityCardLoader = ({ containerClassName = null, width = 400, height = 400, isOnTwoColumns = false }) => {
  const contentLoaderClassName = classNames({
    'base-card': !isOnTwoColumns,
    'base-card-wider': isOnTwoColumns,
    'base-card__loader': true,
  });

  return (
    <div className={containerClassName}>
      <div className="community-card-loader__list">
        {[...Array(12)].map((_, i) => (
          <ContentLoader
            aria-label=""
            backgroundColor="#f3f3f3"
            className={contentLoaderClassName}
            foregroundColor="#ecebeb"
            height={height}
            key={`loading-community-${i}`} // eslint-disable-line react/no-array-index-key
            uniqueKey={`loading-community-${i}`}
            viewBox={`0 0 ${width} ${height}`}
            width={width}
          >
            <rect
              height={height}
              rx="3"
              ry="3"
              width={width}
              x="0"
              y="0"
            />
          </ContentLoader>
        ))}
      </div>
    </div>
  );
};

export default CommunityCardLoader;
